import React from 'react'
import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import { Text } from '~src/new/shared/ui/Text/Text'
import cls from './chip.module.scss'

/**
 * Тоггл-чип для статусов/быстрых фильтров
 * @param {{children: React.ReactNode, active?: boolean, dark?: boolean, disabled?: boolean,
 *   onClick?: Function, className?: string, style?: object}} props
 * @returns {JSX.Element}
 */
export const Chip = props => {
  const {
    children,
    active = false,
    dark = false,
    disabled = false,
    onClick,
    className,
    style,
  } = props

  return (
    <button
      type="button"
      className={classNames(
        cls.chip,
        { [cls.active]: active, [cls.dark]: dark && !active },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      <Text variant="body-small">{children}</Text>
    </button>
  )
}

Chip.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  dark: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
}
